export default __webpack_public_path__ + "static/media/used-car.6010c38c.svg";